import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { yupResolver } from '@hookform/resolvers/yup';
import { Grid } from '@material-ui/core';

import { formSchema } from './form-schema';
import { useStyles } from './styles';

import * as session from '../../utils/session';
import CustomButton from '../../components/CustomButton/CustomButton';
import CustomInputForm from '../../components/CustomInputForm/CustomInputForm';
import { ESQUECI_SENHA_LABELS } from '../../consts/text/esqueci-senha';
import {
  FORM_LOGIN_FIELDS,
  FORM_LOGIN_LABELS,
} from '../../consts/text/form-login';
import { AutenticationActions } from '../../store/ducks/autentication';

function FormEsqueciMinhaSenha() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { register, handleSubmit, formState, setValue } = useForm({
    resolver: yupResolver(formSchema),
  });
  const { errors } = formState;

  const isChabot = session.getChatbot();
  const tagId = isChabot
    ? 'enviar-esqueci-senha-whats-001'
    : 'enviar-esqueci-senha-001';

  const onSubmit = (data) => {
    session.setUserName(data.email);
    dispatch(
      AutenticationActions.postEsqueciSenhaRequest({
        ...data,
      }),
    );
  };

  return (
    <Grid component="form" onSubmit={handleSubmit(onSubmit)} container>
      <Grid item xs={12}>
        <CustomInputForm
          inputRef={register}
          customClass={classes.input}
          errors={errors}
          setValueForm={setValue}
          label={FORM_LOGIN_LABELS.LABEL_EMAIL}
          name={FORM_LOGIN_FIELDS.FIELD_EMAIL}
          data-gtm-form="form"
          data-gtm-name="email"
        />
      </Grid>
      <Grid item xs={12}>
        <CustomButton
          className={classes.button}
          content={ESQUECI_SENHA_LABELS.BTN}
          variant="contained"
          type="submit"
          gtm={{
            id: tagId,
            'data-gtm-name': 'enviar-esqueci-senha',
          }}
        />
      </Grid>
    </Grid>
  );
}

export default FormEsqueciMinhaSenha;
